<template>
  <div>
    <div class="localdiv tright pr15 tc6 pt35 pb15">
      <span class="fs24 fl tc3 lborder prelative pl25 lh10">{{menu[pid]['children'][id]['name']}}</span>
      <div class="pt10">
        当前位置:
        <router-link to="/">学校首页 > </router-link>
        <span>{{menu[pid]['name']}} > </span>
        <router-link :to="{path:'/evn/list',query:{pid:pid,id:id}}">{{menu[pid]['children'][id]['name']}}</router-link>
      </div>
    </div>
    <div class="cont tleft pt40 pb20" id="viewer">
      <nev-item :list="list"></nev-item>
    </div>
    <!---->
    <pagec :page="page" :total="total" :size="perPage" @get-data="getData" :key="id+pid"/>
  </div>
</template>

<script>
import '../../../static/viewer/viewer.min.css'
import Pagec from "./Page";
import NevItem from "./NevItem";
export default {
  name: "ListNev",
  components:{
    Pagec,
    NevItem
  },
  props:[
    'id',
    'pid',
    'list',
    'total',
    'page',
    'menu',
    'perPage',
    'getData',
  ],
  mounted() {
  },
  created() {
    this.getContent();
  },
  updated() {
  },
  methods:{
    goContent(){
      var query = this.$route.query;
      this.$router.push({path:'/evn/detail',query:{name:query.name, pid:query.pid, id:1}})
    },
  },
  watch:{
    list:function(n,o){

    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/un_index/ListNev.vue